import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.addEventListener("change", this.handleChange.bind(this))
    })
  }

  handleChange(event) {
    const checkbox = event.target
    const pairedName = checkbox.dataset.pairedWith
    if (!pairedName) return

    const pairedCheckbox = document.querySelector(`input[name="${pairedName}"]`)
    if (!pairedCheckbox) return

    const isEmissions = checkbox.name.includes("has_emissions")

    if (checkbox.checked && isEmissions) {
      pairedCheckbox.checked = true
    } else if (!checkbox.checked && !isEmissions) {
      pairedCheckbox.checked = false
    }
  }
}